// removed by extract-text-webpack-plugin
module.exports = {"main":"as_as","inner":"as_au","noFooter":"as_aw","header":"as_ay","footer":"as_a0"};


//////////////////
// WEBPACK FOOTER
// ./layouts/main/style.css
// module id = HwER
// module chunks = 7